import styled from 'styled-components';
import { sizes } from 'style';
import { th } from 'style/theme';

export const StyledEarningsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0 10px;
  font-size: 12px;

  @media ${sizes.tabletPortrait} {
    font-size: 16px;
  }

  > thead > tr > th {
    padding: 0;
    vertical-align: bottom;
  }

  > tbody > tr {
    background-color: ${th('colors.turquoise')};

    > * {
      text-align: center;
      padding: 0;
      font-weight: bold;
    }

    color: ${th('colors.white')};
    > :first-child {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }

    > :last-child {
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
  }
`;

export const RowColumnColor = styled.div`
  padding: 8px;
  margin: 0 10px;
  background-color: #6cd4d5;
`;

export const HeadColumnColor = styled.div`
  padding: 4px 8px;
  margin: 0 10px;
  background-color: rgba(136, 233, 234, 0.39);
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  font-size: 12px;

  @media ${sizes.tabletPortrait} {
    font-size: 14px;
  }
`;

export const SmallText = styled.p`
  font-size: 13px;
  margin: 0;
`;

export const SmallTexts = styled.div`
  margin: 20px 0;
`;
